<template>
  <app-base-main>
    <template #filter-group>
      <ClaimTotalHead
        :totalObj="statData"
        type="inventoryClaim"/>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-radio-group
            v-model="claimStatus"
            :options="[
              {id: 0, text: '未索赔'},
              {id: 1, text: '已索赔'},
            ]"
            @input="changeStatus"
        ></gj-radio-group>
        <gj-warehouse-select
            v-model="filter.warehouseIds"
            multiple
            :self="false"
            placeholder="仓库"
            width="180px"
        ></gj-warehouse-select>
        <gj-select
          v-if="claimStatus === 1"
          v-model="filter.alreadyClaimStatus"
          type="multi-check"
          width="140px"
          :multiple="true"
          :options="[

              {id: 2, text: '索赔中'},
              {id: 3, text: '索赔成功'},
              {id: 1, text: '索赔失败'},
            ]"
          placeholder="索赔状态"
        ></gj-select>
        <gj-select-date-picker
          v-if="claimStatus === 1"
          v-model="filter.date"
          type="daterange"
          :options="[
              {id: 'analysisDate', text: '分析时间'},
              {id: 'caseDate', text: 'Case填写时间'},
          ]"
          :width="['140px']"
        >
        </gj-select-date-picker>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'mskus', text: 'MSKU', moreShow: true},
              {id: 'fnskus', text: 'FNSKU', moreShow: true},
              {id: 'asins', text: 'ASIN', moreShow: true},

            ]"
        ></gj-select-input>
      </app-filter-group>
    </template>
    <template #operate-group>
        <gj-button type="primary" v-if="$permission('claim:edit')" @click="totalInputCase" :disabled="noSelect">填写CaseID</gj-button>
        <gj-button v-if="claimStatus === 1 && $permission('claim:edit')" @click="modifyStatus(true)" :disabled="noSelect">更新索赔状态</gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group
          help>
          <template #before>
          <div style="color: #86909C ;font-size: 12px" v-if="claimStatus === 0">
           分析时间：{{createTime}}
          </div>
        </template>
        <template #task-content>
          <TaskBatchManagement ref="task"/>
        </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
        name="claim-inventory"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          :default-sort="{prop: 'quantity', order: 'descending'}"
          selection
          :index="false"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          @selection-change="handleSelectionChange"

      >
        <template v-slot:msku="{ row }">
            <gj-tooltip :content="row.msku" :text-line="1">{{ row.msku }}</gj-tooltip>
            <div  v-if="row.asin">
              <gj-link :href="row.asinUrl" target="_blank">{{ row.asin || '-' }}</gj-link>
               <span v-copy="row.asin" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
              </span>
            </div>
            <div v-else>
              -
            </div>
        </template>

        <template v-slot:fnsku ="{ row }">
            <div> {{ row.fnsku }} </div>
        </template>
        <template v-slot:time ="{ row }">
            <div> {{ row.reportStartTime.slice(0,10) }}~{{row.reportEndTime.slice(0,10)}} </div>
        </template>
        <template v-slot:claimStatus="{ row }">
            <gj-tag type="text" :color="getColor(row.claimStatus)">{{ getStatusName(row.claimStatus) }}</gj-tag>
            <span v-if="row.claimStatus === 1 && $permission('claim:edit')" @click="modifyStatus(false, row)" class="copy-icon gj-cell-display-switch refresh-icon-color">
              <gj-icon class="el-icon-refresh"></gj-icon>
            </span>
        </template>
         <template v-slot:status="{ row }">
            <template >
              <gj-tag type="text" :color="getColor(row.statusName)">{{ row.statusName }}</gj-tag>
            </template>
          </template>
        <template v-slot:memo="{ row }">
          <template v-if="$permission('claim:edit')">
            <ClaimMemoInput
                :value="row.memo"
                :item="row"
                fixedIcon
                table-cell-edit
                :on-confirm="onConfirm"
                :pop-title="'编辑备注'">
            </ClaimMemoInput>
          </template>
          <template v-else>
            <gj-tooltip :content="row.memo" :textLine="1">{{row.memo}}</gj-tooltip>
          </template>

        </template>
        <template v-slot:estimateClaimSingleCost="{ row }">
            <span >{{row.currencySymbol || ''}}{{row.estimateClaimSingleCost | defaultShow}} </span>
        </template>
        <template v-slot:realClaimMoney="{ row }">
            <span >{{row.currencySymbol || ''}}{{row.realClaimMoney | defaultShow}} </span>
        </template>
        <template v-slot:op="{ row }">
          <gj-button-group type="dropdown-op">
            <template v-if="$permission('claim:edit')">
              <gj-button type="text" @click="inputCase(row)">{{claimStatus === 0 ? '填写' : '修改'}}CaseID</gj-button>
            </template>
            <template v-if="$permission('claim:edit')">
              <gj-button type="text" @click="viewTemplate(row)">索赔模板</gj-button>
            </template>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import ClaimTotalHead from '../claim-total-head';
  import {isMeaningful} from "@/utils/common";
  import {getStorageClaimPage, updateStorageClaim, getStoragesClaimStat,getStorageClaimTemplate,refreshStorageClaim} from "@/api/sale";
  import ClaimInputCase from './madal/claim-input-case';
  import ClaimCaseTemplate from './madal/claim-case-template';
  import {convertToDate} from "@/utils/date.util";
  import { tagColors } from '@/components/tag/tag-colors';
  import ClaimMemoInput from '../return-claim/modal/claim-memo-input';
  export default {
    name: "claim-inventory",
    mixins: [queryMixin],
    components: {
      ClaimTotalHead,
      ClaimMemoInput
    },
    created() {
      this.columns = this._.cloneDeep(this.notClaimCol);
    },
    watch: {
      $route: {
        immediate: true,
        handler(router) {
          if (router && router.query.link === 'opDetail' && router.query.timestamp !== this.timestamp) {
            this.isInitParams = false;
            this.filter.keyword.key = 'mskus';
            this.filter.keyword.value = null;
            this.countryAndMarket = {
              countryIds: [router.query.countryCode],
              marketIds: [router.query.marketId],
            };
            this.claimStatus = 0;
            this.columns = this._.cloneDeep(this.notClaimCol);
            this.timestamp = router.query.timestamp;
            this.$gjResetPage();
          }
        },
      },
    },
    data() {
      return {
        statData:{},
        createTime: null,
        tagColors,
        timestamp: null,
        tableData: [],
        columns: [],
        notClaimCol: [
          {id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '160px', fixed: "left"},
          {id: 'image', header: '图片',  field: 'picture:imageUrl', minWidth: '140px', fixed: "left"},
          {id: 'msku', header: 'MSKU/ASIN', field: 'slot:msku', minWidth: '160px', fixed: "left"},
          {id: 'fnsku', header: 'FNSKU', field: 'slot:fnsku', minWidth: '140px', fixed: "left"},
          {id: 'estimateDamageQuantity', header: '残损商品', field: 'estimateDamageQuantity', minWidth: '140px', align: 'right', sortable: true, help: '亚马逊已主动赔偿的商品不再计入'},
          {id: 'estimateLostQuantity', header: '丢失商品', field: 'estimateLostQuantity', minWidth: '140px', align: 'right', sortable: true, help: '亚马逊已主动赔偿的商品不再计入'},
          {id: 'estimateClaimQuantity', header: '预计赔付数量', field: 'estimateClaimQuantity', minWidth: '140px', align: 'right', sortable: true, help: '预计赔付数量=残损商品+丢失商品'},
          {id: 'estimateClaimSingleCost', header: '预计赔付金额', field: 'slot:estimateClaimSingleCost', minWidth: '140px', align: 'right', sortable: true, help: '按照最近一次赔偿单价计算，最近无赔偿单价为0'},
          {id: 'reportTime', header: '盘库报表时间范围', field: 'slot:time', minWidth: '180px', align: 'left', sortable: false, help: '根据对应日期范围内的《盘库》报表统计数据'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '160px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '164px', fixed: 'right', notCustomColumn: true},
        ],
        claimCol: [
          {id: 'warehouseName', header: '仓库', field: 'warehouseName', minWidth: '160px', fixed: "left"},
          {id: 'image', header: '图片',  field: 'picture:imageUrl', minWidth: '140px', fixed: "left"},
          {id: 'msku', header: 'MSKU/ASIN', field: 'slot:msku', minWidth: '160px', fixed: "left"},
          {id: 'fnsku', header: 'FNSKU', field: 'fnsku', minWidth: '140px', fixed: "left"},
          {id: 'estimateDamageQuantity', header: '残损商品', field: 'estimateDamageQuantity', minWidth: '140px', align: 'right', sortable: true, help: '亚马逊已主动赔偿的商品不再计入'},
          {id: 'estimateLostQuantity', header: '丢失商品', field: 'estimateLostQuantity', minWidth: '140px', align: 'right', sortable: true, help: '亚马逊已主动赔偿的商品不再计入'},
          {id: 'estimateClaimQuantity', header: '预计赔付数量', field: 'estimateClaimQuantity', minWidth: '140px', align: 'right', sortable: true, help: '预计赔付数量=残损商品+丢失商品'},
          {id: 'estimateClaimSingleCost', header: '预计赔付金额', field: 'slot:estimateClaimSingleCost', minWidth: '140px', align: 'right', sortable: true, help: '按照最近一次赔偿单价计算，最近无赔偿单价为0'},
          {id: 'reportTime', header: '盘库报表时间范围', field: 'slot:time', minWidth: '180px', align: 'left', sortable: false, help: '根据对应日期范围内的《盘库》报表统计数据'},
          {id: 'createTime', header: '分析时间', field: 'createTime', minWidth: '170px', align: 'right', sortable: true, help: '系统分析并生成此条索赔建议的时间'},
          {id: 'claimStatus', header: '索赔状态', field: 'slot:claimStatus', minWidth: '140px', align: 'right', sortable: false, help: '在您填写caseID后，10天内系统会每天检测《赔偿》报表，更新索赔状态；如超过10天未索赔成功，则自动判别为索赔失败；您可以手动更新索赔状态'},
          {id: 'caseId', header: 'caseID', field: 'caseId', minWidth: '140px', align: 'right', sortable: false,},
          {id: 'claimTime', header: 'case填写时间', field: 'claimTime', minWidth: '160px', align: 'right', sortable: true, help: '填写caseID的时间；如修改caseID，则此时间会更新'},
          {id: 'realClaimQuantity', header: '实际赔付库存量', field: 'realClaimQuantity', minWidth: '150px', align: 'right', sortable: true,},
          {id: 'realClaimCashQuantity', header: '实际赔付金额量', field: 'realClaimCashQuantity', minWidth: '150px', align: 'right', sortable: true,},
          {id: 'realClaimMoney', header: '实际赔付金额', field: 'slot:realClaimMoney', minWidth: '140px', align: 'right', sortable: true,},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '160px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '164px', fixed: 'right', notCustomColumn: true},
        ],
        filter: {
          warehouseIds: [],
          keyword: {
            key: "mskus",
            value: null,
          },
          date: {
            key: 'analysisDate',
            value: null
          },
          alreadyClaimStatus: [],

        },
        claimStatus: 0,
        noSelect: true,

      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        var model = {}
        if (this.claimStatus === 1) {
          if (this.filter.alreadyClaimStatus.length > 0) {
            model.claimStatus = this.filter.alreadyClaimStatus
          }else {
            model.claimStatus = [2,3,1]
          }
        }else {
          model.claimStatus = [0,]
        }
        model.warehouseIds = this.filter.warehouseIds.map(function(item) {
          return item
        })

        this.globalParams = {
          model: model,
          ...this.queryPagination,
          ...this.querySort,
          map:{}
        };
        if (this.claimStatus === 1) {
          if (isMeaningful(this.filter.date.value)){
          const startTime = convertToDate(this.filter.date.value[0]);
          const endTime = convertToDate(this.filter.date.value[1]);
          if (this.filter.date.key === 'analysisDate'){
            this.globalParams.model.createTimeBegin = startTime;
            this.globalParams.model.createTimeEnd = endTime;
          }else if (this.filter.date.key === 'caseDate') {
            this.globalParams.model.caseIdTimeBegin = startTime;
            this.globalParams.model.caseIdTimeEnd = endTime;
          }
        }

        }
        if (isMeaningful(this.filter.keyword.value)) {
          this.globalParams.model[this.filter.keyword.key] = this.filter.keyword.value.split(',') || null;
        }

        getStorageClaimPage(this.globalParams)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
            if(data.records.length > 0) {
              this.createTime = data.records[0].createTime

            }
        }).complete(() => this.loading = false)
        this.getStat();
      },
      onConfirm(memo, data, closeEditor) {
        updateStorageClaim({id: [data.id], memo: memo})
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
            closeEditor();
          })
      },
      getStat(){
        let parmas = this._.cloneDeep(this.globalParams);
        if (this.filter.alreadyClaimStatus.length > 0) {
            parmas.model.claimStatus = this.filter.alreadyClaimStatus
          }else {
            parmas.model.claimStatus = null
          }
        getStoragesClaimStat(parmas).then((data)=>{
          this.statData = data;
        });
      },
      viewTemplate(row) {
        getStorageClaimTemplate(row.id).then((data)=>{
          this.$gjCreate(ClaimCaseTemplate, {
            props: {
              item: row,
              claimTemplate: data
            }
          })
        })
      },
      modifyStatus(batch, row){
        var ids = null;
        var canUpdate = false
        if(batch){
          ids = this.selectedRows.map((item) => {
            if (item.claimStatus === 1) {
              canUpdate = true
            }
            return item.id;
          })
        }else{
          if (row.claimStatus === 1) {
            canUpdate = true
          }
          ids = [row.id];
        }
        if (canUpdate == true) {
          refreshStorageClaim(ids).then((data) => {
            if (data && data == true){
              this.$gjQuery();
              this.$gjMessage.success('操作成功');
            }
          });
        }else {
          this.$gjMessage.error('当前选中的数据不可更新索赔状态，请选择索赔失败的数据再更新索赔状态');
        }
      },
      getStatusName(status) {
        let statusName = '';
        switch (status) {
          case 0:
            statusName = '未索赔';
            break;
          case 1:
            statusName = '索赔失败';
            break;
          case 2:
            statusName = '索赔中';
            break;
          case 3:
            statusName = '索赔成功';
            break;
          case 4:
            statusName = '已过期';
            break;
        }
        return statusName;
      },
      getColor(status) {
        switch (status) {
          case 0:
            return this.tagColors.violetText;
          case 1:
            return this.tagColors.redText;
          case 2:
            return this.tagColors.orangeText;
          case 3:
            return this.tagColors.greenText;
          case 4:
            return this.tagColors.gray6Text;
        }
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            keyword: {
              key: "mskus",
              value: null,
            },
            date: {
              key: 'analysisDate',
              value: null
            },
            alreadyClaimStatus: [],

        },

        }
      },
      changeStatus() {
        if (this.claimStatus === 0) {
          this.columns = this.notClaimCol;
        } else {
          this.columns = this.claimCol;
        }
        this.filter.alreadyClaimStatus = []
        this.$gjNoticeQuery();
      },

      inputCase(row) {
        const modal = this.$gjCreate(ClaimInputCase, {
          props: {
            id: [row.id],
            msku: row.msku,
            item: row.claimStatus === 0 ? null: row,
          },
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      },
      totalInputCase(){
        let row = null
        if (this.selectedRows.length == 1) {
          row = this.selectedRows[0]
        }
        let props = {}

        const modal = this.$gjCreate(ClaimInputCase, {
          props: {
            id: this.getSelectRowIDs(),
            msku: row? row.msku : null,
            item: row? row.claimStatus === 0 ? null: row : null,
          },
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })

        // let props = {}
        // props = {
        //     id: this.getSelectRowIDs(),
        //   }
        //   if (this.selectedRows && this.selectedRows.length == 1) {
        //     props.caseId = this.selectedRows[0].caseId || '';
        //   }

        // const modal = this.$gjCreate(ClaimInputCase, {
        //   props: props,
        //   on: {
        //     after: () => {
        //       this.$gjResetPage();
        //       modal.$gjDestroy();
        //     }
        //   }
        // })
      },
      handleSelectionChange(val) {
        if (val.length > 0) {
          this.noSelect = false;
        }else {
          this.noSelect = true;
        }
        this.selectedRows = val;
      },
       getSelectRowIDs(){
        let selectIds = this.selectedRows?.map((item) => {
          return item.id;
        })
        if (!selectIds) {
          selectIds = [];
        }
        return selectIds;
      },
    }
  }
</script>

<style scoped lang="scss">

</style>
